module.exports = __webpack_public_path__ + "static/youth-group-a8dccb69427f12635ea8d230500384e8.jpg";